import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const DownloadSteps = ({ steps }) => (
  <ol className={styles.steps}>
    {steps.map(step => (
      <li className={styles.item} key={step.anchor}>
        <a href={`#${step.anchor}`}>{step.content}</a>
      </li>
    ))}
  </ol>
);

DownloadSteps.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    anchor: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  }).isRequired).isRequired
};

export default DownloadSteps;
